// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3XHtK","header":"ReportDetails_header__100Ig","title":"ReportDetails_title__2XO0w","left":"ReportDetails_left__1ZFV9"};